// extracted by mini-css-extract-plugin
module.exports = {"overlay":"tutorial_overlay__1NPSb","container":"tutorial_container__1JdMm","close":"tutorial_close__1kjD9","link":"tutorial_link__eMn5q"};